import { AuthProvider } from "lib/auth";

export default function Layout({ children }: { children?: any }): JSX.Element {
  return (
    <>
      <AuthProvider isAuth0Only>{children}</AuthProvider>
    </>
  );
}
